<template>
  <div class="zy-square">
    <div class="zy-square-cnt">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  // 正方形组件
  name: "zy-square"
}
</script>

<style scoped lang="scss">
.zy-square {
  width: 100%;
  height: 0;
  padding-bottom: 100%;
  overflow: hidden;
  position: relative;
  .zy-square-cnt {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    height: 100%;
  }
}

</style>
